import { Translations } from '../model'

export default {
  'filter.label.stations.all': 'Alle Stationen',
  'filter.label.stations.favorites': 'Meine Favoriten',
  'filter.label.stations.recently_played': 'Kürzlich gehört',
  'filter.label.stations.most_played': 'Die meisten hörten zu'
} as Translations
